import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('medical_benefits_set', '/medical_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
